import Icon from "../selfcare/Icon.tsx";
import React from "react";
import {formatPrice} from "../../util/formatter.ts";
import {DispatchHighLightAddressSearchEvent} from "../../util/events.ts";
import IconArrow from "../icons/IconArrow.tsx";

export default function ProductListItemComponent(props: {
    heading: string,
    pre_product_slogan?: string,
    first_time_string: string,
    campaignPrice: number,
    defaultPrice: number,
    first_6_months_price: number,
    after_verb: string,
    up_to_mbit: string,
    highlights: {
        icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>,
        text: string
    }[],
    image: {
        src: string,
        alt: string
    },
    extra_li_class?: string,
    disclaimer_text: string,
    disclaimer_price: number,
    stamp?: React.ReactNode,
    speed_extra?: React.ReactNode

}) {
    return (
        <li className={`product-list-item ${props.extra_li_class}`}>
            <div className="product-list-pre-link-wrap">
                {props.pre_product_slogan !== undefined && (
                    <span className="pre-product">
                        <span>{props.pre_product_slogan}</span>
                    </span>
                )}
            </div>
            <div
                onClick={() => DispatchHighLightAddressSearchEvent(true)}
                className="product-list-link"
            >
                <div className="product-list-card">
                    <h3 className="product-list-heading">
                        {props.heading}
                    </h3>

                    <div className="product-list-middle">
                        <div className="product-list-price-container">
                            <p className="pre-price">
                                Første {props.first_time_string}
                            </p>
                            <p className="product-list-price">
                                <span className="price discount">
                                    {formatPrice(props.campaignPrice)}<span className="comma-dash">,-</span>
                                </span>
                                <span className="md"><span className="thin-slash">/</span>md.</span>
                            </p>
                            <p className="post-price">
                                Herefter {props.after_verb} {formatPrice(props.defaultPrice)}<span className="comma-dash">,-</span>/md.
                            </p>
                            <p className="min-price">
                                Min. pris 6 mdr. {props.after_verb} {formatPrice(props.first_6_months_price)}<span className="comma-dash">,-</span>
                            </p>
                        </div>

                        <figure className="product-list-image">
                            <img
                                src={props.image.src}
                                alt={props.image.alt}
                            />
                            {props.stamp !== undefined && props.stamp}
                        </figure>
                    </div>

                    <hr/>

                    <div className="product-list-tech">
                        <div className="product-list-speed">
                            <span className="mbit">Op til</span>
                            <span className="speed">
                                {props.up_to_mbit}
                            </span>
                            <span className="mbit">Mbit</span>
                        </div>

                        {props.speed_extra !== undefined && props.speed_extra}
                    </div>

                    <hr/>

                    <ul className="product-list-usp">
                        {props.highlights.map((h, i) => {
                            return (
                                <li key={i} className="product-list-usp-item">
                                    <Icon component={h.icon}/>
                                    <span className="text">{h.text}</span>
                                </li>
                            )
                        })}
                    </ul>

                    <div className="product-list-button button">
                        Tjek adresse
                        <Icon component={IconArrow}/>
                    </div>
                </div>
            </div>

            <div className="product-list-disclaimer">
                <p>
                    {props.disclaimer_text} <span className="discount">{formatPrice(props.disclaimer_price)},-</span>
                </p>
            </div>
        </li>
    )
}
